import "@modules/administration/pages/companies/company.locator";
import "@modules/administration/pages/users/user.locator";

import "@modules/authentication/pages/login/login.locator";

import "@modules/chefs-assistant/pages/cash-book/cash-book.locator";
import "@modules/chefs-assistant/pages/stock/products/product.locator";
import "@modules/chefs-assistant/pages/technical-sheets/technical-sheet.locator";

import "@modules/health/health.locator";

import "@modules/changeman/pages/text-content/text-content.locator";

import "@modules/main/pages/user-profile/user-profile.locator";

import { mainLocator } from "@core/di/main.locator";

export const locator = mainLocator;
